import { FormError } from "app/containers/types";
import { TRANSLATE } from "utils/helpers";

export const onValidate = (form) => {
  const errors: FormError[] = [];
  if (form?.name?.value?.length === 0) {
    errors.push({
      name: "name",
      error: TRANSLATE("TREATMENT_TYPES.NAME_REQUIRED"),
    });
  }
  if (form.beforeAfter.value?.length === 0) {
    errors.push({
      name: "beforeAfter",
      error: TRANSLATE("TREATMENT_TYPES.BEFORE_AFTER_REQUIRED"),
    });
  }
  if (form.hours.value?.length === 0) {
    errors.push({
      name: "hours",
      error: TRANSLATE("TREATMENT_TYPES.HOURS_REQUIRED"),
    });
  }
  if (
    form.session_id.value === "" ||
    form.session_id.value === undefined ||
    form.session_id.value === null
  ) {
    errors.push({
      name: "session_id",
      error: TRANSLATE("TREATMENT_TYPES.SESSION_ID_REQUIRED"),
    });
  }
  if (form.description.value?.length === 0) {
    errors.push({
      name: "description",
      error: TRANSLATE("TREATMENT_TYPES.DESCRIPTION_REQUIRED"),
    });
  }
  if (!form.shortDescription?.value?.length) {
    errors.push({
      name: "shortDescription",
      error: TRANSLATE("TREATMENT_TYPES.SHORT_DESCRIPTION_REQUIRED"),
    });
  }
  if (!String(form.category?.value ?? "").length) {
    errors.push({
      name: "category",
      error: TRANSLATE("TREATMENT_TYPES.CATEGORY_REQUIRED"),
    });
  }
  const hasResource = (form.resources ?? []).some(
    (r) => !r.isDeleted && r.resourcePath
  );
  if (!hasResource) {
    errors.push({
      name: "resourceError",
      error: TRANSLATE("TREATMENT_TYPES.AT_LEAST_ONE_FILE_REQUIRED"),
    });
  }
  return errors;
};

export const isDuplicate = (form, treatments) => {
  const treatmentsExceptSelected = form?.id?.value
    ? treatments.filter((f) => f.id != form.id.value)
    : treatments;
  const duplicate = treatmentsExceptSelected.find(
    (treatment) =>
      treatment.name === form.name.value && treatment?.id !== form.id?.value
  );
  return !!duplicate;
};
